import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/areaPrintCollection/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/areaPrintCollection/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/areaPrintCollection/remove', qs.stringify(params),options);

export const removeAll = (params, options) =>
  request.post('/api/areaPrintCollection/removeAll', qs.stringify(params),options);

export const addPrintCollection = (params, options) =>
request.post('/api/areaPrintCollection/save', qs.stringify(params),options);

export const update = (params, options) =>
request.post('/api/areaPrintCollection/update', params,options);

// 获取打印集中所有二维码
export const getAllPrintQrcode = (params, options) =>
request.get('/api/areaPrintCollection/detail', Object.assign({}, options, { params }));